import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@yardzen/ui/lib/utils";

type StarColor = "gold" | "black";

const STAR_COLOR_CLASSES: Record<StarColor, string> = {
  gold: "fill-scheme-star text-scheme-star",
  black: "fill-[#000] text-[#000]",
};

/**
 * Shared star-rating pill used by Reviews and StarRating. Renders N filled
 * stars followed by optional trailing text (e.g. "(16,640 Reviews)") inside a
 * rounded, translucent white pill. Keep visual style aligned with the Reviews
 * chip on the Toll Brothers LP.
 */
export function StarPill({
  count = 5,
  text,
  color = "gold",
  starSizeClass = "text-base",
  textClass = "font-display text-sm",
  className,
}: {
  count?: number;
  text?: React.ReactNode;
  color?: StarColor;
  starSizeClass?: string;
  textClass?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "inline-flex flex-row items-center gap-2 rounded-full bg-white/50 px-4 py-2",
        className,
      )}
      aria-label="rating"
    >
      <div className={cn("flex items-center gap-1", starSizeClass)}>
        {Array.from({ length: count }).map((_, i) => (
          <FontAwesomeIcon
            key={i}
            icon={faStar}
            className={STAR_COLOR_CLASSES[color]}
            aria-hidden="true"
          />
        ))}
      </div>
      {text ? <span className={textClass}>{text}</span> : null}
    </div>
  );
}
